import "./SearchBar.less";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification } from "antd";
import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";
import { SearchOptions } from "lib/data/transfer";

import { Button } from "components/general";
import Search from "antd/lib/input/Search";

interface ISearchBarProps extends IBaseProps {
	autoFocus?: boolean;
	placeholder?: string;
	searchString?: string;
	onSearch: (search: string) => void;
	useCustomInput?: boolean;
	title?: string;
}

export class SearchBar extends React.Component<ISearchBarProps, any> {

	private searchValue: string | undefined;

	constructor(props: ISearchBarProps) {

		super(props);
	}

	public render() {

		// Define Class Name
		const className = "search-bar" + (this.props.className ? ` ${this.props.className}` : "");

		return (
			<div className={className}>

				<div className="search-wrapper">

					<div className="search-bar-title">
						{this.props.title}
					</div>

					{
						this.props.useCustomInput
						?
						<>
							<input
								className="search-box"
								type="text"
								placeholder={(this.props.placeholder ? this.props.placeholder : "Search")}
								defaultValue={this.props.searchString ? this.props.searchString : ""}
								onKeyPress={this.onKeyPress}
								onChange={this.onSearchValueChanged}
								autoFocus={this.props.autoFocus}
							/>

							<Button
								className="search-button"
								hasBorder={true}
								onClick={() => this.onSearch(this.searchValue)}
							>
								<FontAwesomeIcon icon={["fas", "search"]} />
							</Button>
						</>
						:
						<Search
							className="custom-antd-search-box"
							placeholder={(this.props.placeholder ? this.props.placeholder : "Search")}
							defaultValue={this.props.searchString ? this.props.searchString : ""}
							onKeyPress={this.onKeyPress}
							onChange={this.onSearchValueChanged}
							onSearch={this.onSearch}
							autoFocus={this.props.autoFocus}
							size="large"
							enterButton={true}
						/>
					}

				</div>

			</div>
		);
	}

	private onKeyPress = (event: React.KeyboardEvent<any>) => {

		// Check Key Pressed
		switch (event.key) {

			case "Enter":

				// Perform Search
				this.onSearch(this.searchValue);

				break;
		}
	}

	private onSearchValueChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

		// Set Updated Value
		this.searchValue = event.currentTarget.value;
	}

	private onSearch = (searchString: string | undefined) => {

		// Ensure String Is Provided
		if (searchString) {

			// Set Blacklisted Keywords
			const options: SearchOptions = new SearchOptions();

			// Check String For Minimum Length
			if (searchString.length >= options.minimumLength) {

				// Check String For Prohibited Keywords
				if (options.blacklist.find((keyword) => keyword.match(new RegExp(searchString.trim(), "i")) !== null) === undefined) {

					// Call Event Handler
					this.props.onSearch(searchString);
				}
				else {

					// Notify User
					notification.error({
						message: `Unable to only search for blacklisted keyword: ${searchString}`
					});
				}
			}
			else {

				// Notify User
				notification.error({
					message: `Must search for a minimum of ${options.minimumLength} characters`
				});
			}
		}
	}
}
